import React from 'react'
import { DashboardLayout } from '../../layouts'
import { ContentOfficial } from './components/content-official'
import { ContentVerified } from './components/content-verified'
import { ListNav } from './components'
import auth from '../../utils/auth'

const DashboardProfile = ({defaultTab}) => {
  const { isOfficial } = auth()
  const title = isOfficial ? 'Organization Profile' : 'My Profile'

  const [activeTab, setActiveTab] = React.useState(defaultTab || 'About')

  React.useEffect(() => {
    if (
      defaultTab
      && defaultTab.length > 0
      && defaultTab !== false
    ) {
      setActiveTab(defaultTab)
    }
  }, [defaultTab])

  return (
    <DashboardLayout
      title={title}
      mobileNav={isOfficial ? <ListNav activeTab={activeTab} onChange={setActiveTab}/> : undefined}
    >
      {
        isOfficial &&
        <ContentOfficial
          defaultTab={defaultTab ? defaultTab : false}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      }
      {
        !isOfficial &&
        <ContentVerified />
      }
    </DashboardLayout>
  )
}

export { DashboardProfile }
